export const STATUS_LABELS = {
  'new': 'Novo',
  'contact': 'Contato',
  'negotiation': 'Negociação',
  'converted': 'Convertido',
  'lost': 'Perdido',
  'agendado_apresentacao': 'Agendado Apresentação',
  'no_show_treinamento': 'No-Show Treinamento',
  'em_apresentacao': 'Em Apresentação',
  'follow_up': 'Follow Up',
  'aguardando_treinamento': 'Aguardando Treinamento',
  'teste_gratis': 'Teste Grátis'
};
